import { render, staticRenderFns } from "./assist-do-end.vue?vue&type=template&id=2afdb6db&scoped=true"
import script from "./assist-do-end.vue?vue&type=script&lang=ts"
export * from "./assist-do-end.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afdb6db",
  null
  
)

export default component.exports